{
  "heroTitle": "Пригласи друзей",
  "heroSub": "За каждое успешное приглашение на бонусный баланс сразу зачисляется {{bonus}}. Когда друг сделает депозит, {{percent}}% этой суммы через {{days}} дня перейдёт на ваш реальный баланс — вывод в любое время.",
  "yourLink": "Ваша пригласительная ссылка",
  "linkHint": "Это ссылка на Telegram-бота. Друг переходит по ней и подключается к боту с вашим приглашением.",
  "copy": "Копировать",
  "copied": "Скопировано",
  "share": "Поделиться",
  "more": "Ещё",
  "shareText": "Подключайся к боту VBB PLAY! {{bonus}} бонус за приглашение и ещё {{percent}}% от депозитов друга — тебе.",
  "infoTitle": "Информация",
  "infoSignup": "За каждого приглашённого друга сразу начисляется {{bonus}} на бонусный баланс. Средства только для бонусных игр, не смешиваются с реальным балансом и не выводятся напрямую.",
  "infoBonusGames": "Бонусные игры: откройте раздел «Бонусные игры». Запускайте игру с оплатой с бонусного баланса. Выигрыши остаются на бонусе до выполнения условий отыгрыша; обычные сессии на реальные деньги этот бонус не тратят.",
  "infoDeposit": "Когда приглашённый друг сделает подтверждённый депозит, {{percent}}% суммы фиксируется как ваша комиссия. Пример: друг внёс {{exampleDeposit}} — вам {{exampleCommission}}.",
  "infoHold": "Комиссия с депозита автоматически переходит на реальный баланс через {{days}} дня. До этого сумма в статусе «ожидание», после — доступна к выводу.",
  "infoWithdraw": "После зачисления на реальный баланс вы можете вывести средства через Кассу по правилам платформы.",
  "infoUnique": "У каждого игрока своя уникальная ссылка. Самоприглашение невозможно.",
  "invitedLabel": "Приглашённые",
  "friendsUnit": "друг",
  "earningsLabel": "Доход с приглашений",
  "earningsSplit": "бонус {{bonus}} · реал {{real}}",
  "earningsPending": "ожидание {{amount}} ({{days}} дн.)",
  "friendsTitle": "Ваши друзья",
  "friendsCount": "{{count}} чел.",
  "friendsEmpty": "Вы ещё никого не пригласили",
  "friendId": "ID: {{id}}",
  "friendDeposit": "Депозит: {{amount}}",
  "friendEarned": "Вам: {{amount}}",
  "friendPending": "Ожидание: {{amount}}",
  "friendPendingUntil": "На реальный баланс {{date}}",
  "loginRequired": "Войдите, чтобы увидеть ссылку.",
  "navLabel": "Пригласить друга"
}
